module.exports = __webpack_public_path__ + "static/media/Q4_Back_Left.b536abcf.png";